enum ProfilePageTab {
  Information,
  Photo,
  Review,
}

enum DesktopProfilePageTab {
  Public,
  Photo,
  Private,
  Verification,
}

enum ProfilePageAccordion {
  PublicProfile,
  FoodPreferences,
  PublicChefOffering,
  PrivateAccountInformation,
  PrivateSocialVerificationInformation,
  PrivateAccountVerificationInformation,
  // COMMENTED OUT: Contract signing requirement removed
  // ContractSign,
}

export { ProfilePageTab, DesktopProfilePageTab, ProfilePageAccordion };
